//export const API = "https://mobile-api.kssc.org.sa/api/";
export const API = "https://api.kssc.org.sa/api/";
//export const API = "http://localhost:63440/api/";